<template>
    <section>
        <p class="healthcareClass">
            <span style="padding: 10px 10px 40px 10px; font-weight: 700; color: black">Showing {{ hospitalsItems.length }} healthcare providers</span>
        </p>
        <v-row v-if="!loading.hospital && hospitalsItems && hospitalsItems.length > 0">
            <v-col
                v-for="(hosp, index) in hospitalsItems"
                :key="index"
                cols="12"
                sm="6"
                md="4"
                class="d-flex"
            >
                <v-card 
                    class="hosp-item-partner d-flex flex-column pa-4 w-100" 
                    @click="displayDoctorsFromHospital(hosp)"
                >
                    <h3 class="text-h6 font-weight-bold mb-3">
                        {{ hosp.hosp_name }}
                    </h3>

                    <!-- Address Section -->
                    <div class="d-flex align-start mb-4">
                        <v-icon class="mr-2">
                            {{ mdiHospitalMarker }}
                        </v-icon>
                        <span>
                            {{ hosp.hosp_address }}
                        </span>
                    </div>

                    <!-- Location Footer -->
                    <div class="mt-auto pt-2 border-top">
                        <div class="d-flex align-center mb-1">
                            <v-icon class="mr-2">
                                {{ mdiMapMarkerRadius }}
                            </v-icon>
                            <span>{{ hosp.city_name }}</span>
                        </div>
                        
                        <div class="d-flex align-center">
                            <v-icon class="mr-2">
                                {{ mdiMapMarker }}
                            </v-icon>
                            <span>
                                {{ hosp.hosp_region }} &bull; {{ hosp.city_province }}
                            </span>
                        </div>
                    </div>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-else-if="!loading.hospital" style="padding: 25px;">
            <v-col class="text-center" style="border-radius: 12px; border: 2px dashed #4EB352;">
                <v-icon size="80" color="success">
                    {{ mdiMapSearchOutline }}
                </v-icon>
                <h1 style="margin: 30px 0; color: #4CAF50; font-size: 23px;">
                    No Hospitals Found
                </h1>
                <p>We couldn't find any hospitals matching your search criteria. Try adjusting your filters.</p>
            </v-col>
        </v-row>
        <v-row v-else style="height: 50px;">
            <v-progress-linear
                color="success"
                reverse
                height="25"
                indeterminate
            />
        </v-row>
        <v-btn
            v-if="showGoToTop"
            color="success"
            fab
            large
            style="position: fixed; bottom: 18px; right: 10%; z-index: 20;"
            @click="handleGoToTop"
        >
            <v-icon>{{ mdiMenuUp }}</v-icon>
        </v-btn>
        <HospitalDoctorsTable
            :show="displayDoctorsTable"
            :hospital="hospital"
            :hospital-data="selectedHosp"
            :loading="loading"
            @closeDialog="displayDoctorsTable = false"
        />
    </section>
</template>

<script>
import { mdiHospitalMarker, mdiMapMarker, mdiMapMarkerRadius, mdiMapSearchOutline, mdiMenuUp } from '@mdi/js'
import HospitalDoctorsTable from '../dialog_tables/HospitalDoctorsTable.vue'
import { mapGetters, mapActions } from 'vuex'
export default {
    components: {
        HospitalDoctorsTable
    },
    props: ['loading', 'search'],
    data() {
        return {
            mdiHospitalMarker, mdiMapMarker, mdiMapMarkerRadius, mdiMapSearchOutline, mdiMenuUp,
            hospitalsItems: [],
            showGoToTop: false,
            goToOptions: {
                duration: 500,
                offset: 700,
                easing: 'easeInOutCubic'
            },
            selectedHosp: null,
            displayDoctorsTable: false,
            hospital: null,
            headers: [
                { align: 'left', text: 'Hospital', sortable: true, value: 'hosp_name' },
                { align: 'center', text: 'Address', sortable: true, value: 'hosp_address' },
                { align: 'center', text: 'City', sortable: true, value: 'city_name' },
                { align: 'center', text: 'Region', sortable: true, value: 'city_region' },
                { align: 'center', text: 'Province', sortable: true, value: 'city_province' }
            ]
        }
    },
    computed: {
        ...mapGetters(['getRegions', 'getProvinces', 'getCities', 'getHospClin', 'getHospClinDialog'])
    },
    watch: {
        getHospClinDialog() {

        },
        getHospClin(newVal) {
            if (this.search.value) {
                this.hospitalsItems = this.getHospClin.filter(item => item.hosp_name.toLowerCase().includes(this.search.value.toLowerCase()) )
            } else {
                this.hospitalsItems = newVal
            }
            this.loading.hospital = false
        },
        'search.value'(newVal) {
            if (newVal) {
                this.hospitalsItems = this.getHospClin.filter(item => item.hosp_name.toLowerCase().includes(newVal.toLowerCase()) )
            } else {
                this.hospitalsItems = this.getHospClin
            }
        }
    },
    mounted() {
        window.addEventListener('scroll', this.checkScroll)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.checkScroll)
    },
    methods: {
        ...mapActions(['regions', 'provinces', 'cities', 'hospClin', 'hospClinDialog', 'getCsrfToken']),
        checkScroll() {
            this.showGoToTop = window.scrollY > 1000 // adjust threshold as needed
        },
        handleGoToTop() {
            let el = document.querySelector('.healthcareClass')
            if (el) this.$vuetify.goTo(el, this.goToOptions)
        },
        async displayDoctorsFromHospital(hosp) {
            //gets the hospital name and pass it into vuex to get the doctors available to that hospital
            this.loading.tempHospital = true
            await this.hospClinDialog({
                PTYPE: 'H',
                HOSP_MSU: hosp.hosp_msu_code,
                SPEC: ''
            })
            // this.retrieveDoctorsInHospital(hosp.hosp_msu_code)
            this.displayDoctorsTable = !this.displayDoctorsTable
            this.selectedHosp = hosp
            this.hospital = hosp.hosp_name
        }
    }
}
</script>

<style>
.hosp-item-partner h3 {
  margin-bottom: 16px !important;
  color: #1f2937;
  line-height: 1.3;
}
.hosp-item-partner {
  padding: 24px !important;
  margin-bottom: 16px;
  min-height: 220px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  border: 2px solid transparent;
}
  .hosp-item-partner .v-chip {
    font-weight: 600 !important;
    font-size: 12px !important;
    margin-top: 16px;
    align-self: flex-start;
  }
.hosp-item-partner:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(78, 179, 82, 0.15);
  border-color: #4EB352;
}
  .hosp-item-partner ul {
    display: grid;
    gap: 12px;
    margin-bottom: 8px;
  }
    .hosp-item-partner ul li {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      width: 100%;
    }
      .hosp-item-partner ul li i {
        color: #4EB352 !important;
        font-size: 18px !important;
        margin-top: 2px;
        flex-shrink: 0;
      }
        .hosp-item-partner ul li span {
          flex: 1;
          font-size: 14px;
          color: #6b7280;
          line-height: 1.4;
        }
</style>
